module.exports = __webpack_public_path__ + "static/img/step-1013.dcc074c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tutorial/sery/step-1013.png
// module id = UdAQ
// module chunks = 1